import React from "react";
import { Modal } from "react-bootstrap";
import MediaUploader from "../MediaUploader";

export default class MediaUploaderModal extends React.Component {
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  init_state = {
    show: false,
    body: {
      attachments: this.props.attachments,
      text: this.props.text
    }
  };
  state = this.init_state;
  hocWrapper = React.createRef();
  mediaUploaded = medium => {
    this.handleClose();
    this.props.mediaUploaded(medium);
  };
  render() {
    return (
      <>
        <div
          ref={this.hocWrapper}
          className={`hor_click ${this.props.className}`}
        >
          {this.props.children}
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body className="tweet-box">
            <MediaUploader onUploaded={this.mediaUploaded} />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
